"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Loading: ['loading', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12 0.747L12 4.497', 'M12 23.247L12 19.497', 'M4.045 4.042L6.697 6.694', 'M19.955 19.952L17.303 17.301', 'M0.75 11.997L4.5 11.997', 'M23.25 11.997L19.5 11.997', 'M4.045 19.952L6.697 17.301', 'M19.955 4.042L17.303 6.694']],
  LoadingBar: ['loading-bar', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 2.247 L23.250 2.247 L23.250 21.747 L0.750 21.747 Z', 'M0.75 6.747L23.25 6.747', 'M17.25,17.247a3,3,0,0,0,0-6H6.75a3,3,0,0,0,0,6Z', 'M6.75 11.247L6.75 17.247', 'M9.75 11.247L9.75 17.247', 'M12.75 11.247L12.75 17.247']],
  LoadingBar1: ['loading-bar-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 2.247 L23.250 2.247 L23.250 21.747 L0.750 21.747 Z', 'M0.75 6.747L23.25 6.747', 'M17.25,17.247a3,3,0,0,0,0-6H6.75a3,3,0,0,0,0,6Z', 'M12 11.247L10.5 17.247', 'M8.25 11.247L6.75 17.247']],
  LoadingLine: ['loading-line', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.876 11.997 A3.000 3.000 0 1 0 16.876 11.997 A3.000 3.000 0 1 0 10.876 11.997 Z', 'M1.5,12a.375.375,0,1,0,.375.375A.375.375,0,0,0,1.5,12h0', 'M4.876 11.997 A1.500 1.500 0 1 0 7.876 11.997 A1.500 1.500 0 1 0 4.876 11.997 Z', 'M19.876 11.997 A1.500 1.500 0 1 0 22.876 11.997 A1.500 1.500 0 1 0 19.876 11.997 Z']],
  Loading2: ['loading-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M8.172 1.497L9.762 5.247 14.262 5.247 15.851 1.497 8.172 1.497z', 'M19.178 3.416L16.728 6.67 18.981 10.565 23.023 10.064 19.178 3.416z', 'M23.014 13.984L18.974 13.463 16.702 17.347 19.137 20.613 23.014 13.984z', 'M4.845 3.416L7.295 6.67 5.042 10.565 1 10.064 4.845 3.416z', 'M1.009 13.984L5.049 13.463 7.321 17.347 4.886 20.613 1.009 13.984z', 'M15.851 22.497L14.262 18.747 9.762 18.747 8.172 22.497 15.851 22.497z']],
  LoadingLine1: ['loading-line-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 11.997 A3.750 3.750 0 1 0 8.250 11.997 A3.750 3.750 0 1 0 0.750 11.997 Z', 'M11.250 11.997 A3.000 3.000 0 1 0 17.250 11.997 A3.000 3.000 0 1 0 11.250 11.997 Z', 'M20.250 11.997 A1.500 1.500 0 1 0 23.250 11.997 A1.500 1.500 0 1 0 20.250 11.997 Z']],
  LoadingHalf: ['loading-half', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.750 11.997 A3.750 3.750 0 1 0 23.250 11.997 A3.750 3.750 0 1 0 15.750 11.997 Z', 'M8.625 22.497L8.625 22.497', 'M8.625,22.5A.375.375,0,1,0,9,22.872a.375.375,0,0,0-.375-.375', 'M0.750 16.497 A1.500 1.500 0 1 0 3.750 16.497 A1.500 1.500 0 1 0 0.750 16.497 Z', 'M2.250 7.872 A1.875 1.875 0 1 0 6.000 7.872 A1.875 1.875 0 1 0 2.250 7.872 Z', 'M9.750 3.372 A2.625 2.625 0 1 0 15.000 3.372 A2.625 2.625 0 1 0 9.750 3.372 Z']],
  Loading3: ['loading-3', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.394,16.31a11.281,11.281,0,0,0,0-8.621L17.1,10.766a5.284,5.284,0,0,1,0,2.467Z', 'M6.75,12A5.283,5.283,0,0,1,6.9,10.766L1.606,7.689a11.281,11.281,0,0,0,0,8.621L6.9,13.233A5.281,5.281,0,0,1,6.75,12Z', 'M13.5,6.968a5.236,5.236,0,0,1,2.094,1.205L20.883,5.1A11.238,11.238,0,0,0,13.5.849Z', 'M15.594,15.826A5.238,5.238,0,0,1,13.5,17.032V23.15A11.238,11.238,0,0,0,20.883,18.9Z', 'M8.406,8.173a5.236,5.236,0,0,1,2.094-1.2V.849A11.238,11.238,0,0,0,3.117,5.1Z', 'M10.5,17.032a5.238,5.238,0,0,1-2.094-1.206L3.117,18.9A11.238,11.238,0,0,0,10.5,23.15Z']],
  Loading1: ['loading-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.5,7.9a.534.534,0,0,0,1,0l2.436-6.759a11.289,11.289,0,0,0-5.876,0Z', 'M11.5,16.1a.533.533,0,0,1,1,0l2.436,6.759a11.318,11.318,0,0,1-5.876,0Z', 'M8.7,14.484a.534.534,0,0,0-.5-.87l-7.071,1.27a11.3,11.3,0,0,0,2.938,5.089Z', 'M15.805,10.381a.534.534,0,0,1-.5-.87l4.635-5.489a11.287,11.287,0,0,1,2.938,5.089Z', 'M15.3,14.484a.534.534,0,0,1,.5-.87l7.071,1.27a11.3,11.3,0,0,1-2.938,5.089Z', 'M8.2,10.381a.534.534,0,0,0,.5-.87L4.064,4.022A11.287,11.287,0,0,0,1.126,9.111Z']],
  LoadingCircle1: ['loading-circle-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,4.447a7.5,7.5,0,1,1-7.5,7.5', 'M22.942,14.523a11.42,11.42,0,0,1-1.087,2.848', 'M19.814,20.031a12.161,12.161,0,0,1-2.455,1.81', 'M12.993.747a11.137,11.137,0,0,1,2.971.682', 'M18.888,3.065a10.807,10.807,0,0,1,2.131,2.178', 'M22.6,8.2a10.5,10.5,0,0,1,.614,2.984', 'M14.25,22.972A11.252,11.252,0,0,1,9.75.922']],
  LoadingCircle2: ['loading-circle-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 11.997 A11.250 11.250 0 1 0 23.250 11.997 A11.250 11.250 0 1 0 0.750 11.997 Z', 'M8.252,17.612a6.751,6.751,0,0,1,2.257-12.2', 'M18.3,14.394a6.724,6.724,0,0,1-1.558,2.4', 'M14.058,18.425a6.689,6.689,0,0,1-2.849.272', 'M10.500 5.247 A1.500 1.500 0 1 0 13.500 5.247 A1.500 1.500 0 1 0 10.500 5.247 Z']],
  LoadingCircle: ['loading-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.814 4.253L7.578 6.68', 'M2 9.503L4.853 10.43', 'M2 15.992L4.853 15.065', 'M5.814 21.242L7.578 18.815', 'M11.986 23.247L11.986 20.247', 'M18.158 21.242L16.394 18.815', 'M21.972 15.992L19.119 15.065', 'M21.972 9.503L19.119 10.43', 'M18.158 4.253L16.394 6.68', 'M11.986 0.747L11.986 6.747']]
};
exports["default"] = _default;